var map = {
	"./de/hos.yml": 155,
	"./de/main.yml": 28,
	"./de/sfs.yml": 156,
	"./en/example.yml": 157,
	"./en/hos.yml": 158,
	"./en/main.yml": 29,
	"./en/markdown.yml": 159,
	"./en/news.yml": 160,
	"./en/sfs.yml": 161,
	"./fr/example.yml": 162,
	"./fr/hos.yml": 163,
	"./fr/main.yml": 30,
	"./fr/markdown.yml": 164,
	"./fr/news.yml": 165,
	"./fr/sfs.yml": 166,
	"./hr/hos.yml": 167,
	"./hr/main.yml": 31,
	"./hr/sfs.yml": 168,
	"./hu/hos.yml": 169,
	"./hu/main.yml": 32,
	"./hu/sfs.yml": 170,
	"./it/hos.yml": 171,
	"./it/main.yml": 33,
	"./it/sfs.yml": 172,
	"./oc/hos.yml": 173,
	"./oc/main.yml": 34,
	"./oc/sfs.yml": 174
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 154;